import globalConfiguration from '@/api/config/globalConfiguration'
import { queryKeys } from '@/constant/common'
import { APIResponseList, SearchParams } from '@/types/common'
import { GlobalConfiguration } from '@/types/globalConfiguration'
import { QueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

function useSearchGlobal(
  interfaceId: any,
  searchParams: SearchParams = {},
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<GlobalConfiguration>, any> {
  return useQuery(
    [queryKeys.globalConfiguration, interfaceId, searchParams],
    async () => {
      const { data } = await globalConfiguration.getAll(
        interfaceId.toString(),
        {
          ...searchParams,
        },
      )

      if (!data) return null

      return {
        list: data?.data,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    queryOptions,
  )
}

export default useSearchGlobal
